import React, { useContext, useEffect, useState } from "react";
import { TMDataContext } from "../utils/custom_hooks/TMDataContext";

export const DataCourier = ({ pageLoaded, isCustom }) => {
  const { selectedPatientGoals, goalTemplateSet } = useContext(TMDataContext);
  const [patientGoalsXML, setPatientGoalsXML] = useState<string>(
    `<patient-goal-set></patient-goal-set>`
  );
  const [goalTemplatesXML, setGoalTemplatesXML] = useState<string>(
    `<goal-template-set></goal-template-set>`
  );

  const escapeHTML = (string) => {
    var entityMap = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "/": "&#x2F;",
      "%": "&#37;",
    };

    if (string == "" || string == null || string == undefined) {
      return string;
    }
    return String(string).replace(/[%&<>"'\/]/g, function (s) {
      return entityMap[s];
    });
  };

  useEffect(() => {
    preparePatientGoals(selectedPatientGoals);
    prepareGoalTemplates(goalTemplateSet);
  }, [selectedPatientGoals, goalTemplatesXML, isCustom]);

  const preparePatientGoals = (selections) => {
    if (!selections || isCustom)
      return setPatientGoalsXML("<patient-goal-set></patient-goal-set>");

    let formattedPayload = [];
    selections.forEach((selection) => {
      let xmlObject = `<patient-goal><goal-template-id>${
        selection.goalTemplate.id
      }</goal-template-id><name>${escapeHTML(selection.name)}
        </name><achievement-target>${
          selection.achievementTarget
        }</achievement-target><id>${
        selection.id ? selection.id : null
      }</id><leaderboard-included>${
        selection.leaderboardIncluded
      }</leaderboard-included><type>${
        selection.type.name
      }</type><initial-reading>${
        selection.initialReading
      }</initial-reading></patient-goal>`;
      formattedPayload.push(xmlObject);
    });
    var labelledPatientGoalPayload = `<patient-goal-set>${formattedPayload.join(
      ""
    )}</patient-goal-set>`;

    setPatientGoalsXML(labelledPatientGoalPayload);
  };

  const prepareGoalTemplates = (goalTemplateSet) => {
    let formattedTemplates = [];
    goalTemplateSet.forEach((template) => {
      let xmlObject = `<id>${template.id}</id>`;
      formattedTemplates.push(xmlObject);
    });
    var labelledGoalTemplatePayload = `<goal-template-set>${formattedTemplates.join(
      ""
    )}</goal-template-set>`;

    if (isCustom) {
      setGoalTemplatesXML("<goal-template-set></goal-template-set>");
    } else {
      setGoalTemplatesXML(labelledGoalTemplatePayload);
    }
  };

  return (
    <div
      id="patient_goals_dataPackage"
      style={{ display: "none" }}
      data-goalsetuploaded={pageLoaded}
      data-patientgoalxml={patientGoalsXML}
      data-goaltemplatexml={goalTemplatesXML}
    ></div>
  );
};
